import moment from 'moment';
import { useMemo } from 'react';

export function checkCollision(listingTimes, BlockedTimes) {
  for (const listing of listingTimes) {
    const listingStart = moment(listing.startingShiftDateTime);
    const listingEnd = moment(listing.endingShiftDateTime);

    const collides = BlockedTimes.some(blocked => {
      const blockedStart = moment(blocked.startingShiftDateTime);
      const blockedEnd = moment(blocked.endingShiftDateTime);
      return (
        listingStart.isSame(blockedStart) ||
        listingEnd.isSame(blockedEnd) ||
        listingStart.isSame(blockedEnd) ||
        listingEnd.isSame(blockedStart) ||
        listingStart.isBetween(blockedStart, blockedEnd) ||
        listingEnd.isBetween(blockedStart, blockedEnd) ||
        (blockedStart.isBetween(listingStart, listingEnd) ||
          blockedEnd.isBetween(listingStart, listingEnd))
      );
    });

    if (collides) {
      return true; // Return true on the first collision
    }
  }

  return false; // Return false if no collision is found
}
export const constructTimesArray = listing => {
  let { startDate, endDate, startTime, endTime } = {};
  let attendanceArray = [];
  const userOffeset = moment().utcOffset();
  if (listing?.attributes?.publicData?.scheduleType === 'oneTime') {
    // forOneTimeSchedulingTimeCalculation(listingData);
    const startTimeHour = parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.startTime?.hours?.value
    );
    const startTimeMinute = parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.startTime?.min?.value
    );
    const endTimeHour = parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.endTime?.hours?.value
    );
    const endTimeMinute = parseInt(
      listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.endTime?.min?.value
    );

    startDate = moment(listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.startDate?.date)
      .set({ hours: startTimeHour, minutes: startTimeMinute })
      .add(userOffeset, 'm');

    endDate = moment(listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.startDate?.date)
      .set({ hours: endTimeHour, minutes: endTimeMinute })
      .add(userOffeset, 'm');

    if (startTimeHour > endTimeHour) {
      endDate.add(1, 'day');
    }

    startTime = startDate.format('HH:mm');
    endTime = endDate.format('HH:mm');

    const date = startDate;
    const startingShiftDateTime = startDate;
    const endingShiftDateTime = endDate;

    attendanceArray = [
      {
        startingShiftDateTime: new Date(startingShiftDateTime).toISOString(),
        endingShiftDateTime: new Date(endingShiftDateTime).toISOString(),
      },
    ];
  } else {
    const startTimeHour = parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.[0]?.startTime?.hours?.value
    );
    const startTimeMinute = parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.[0]?.startTime?.min?.value
    );
    const endTimeHour = parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.[0]?.endTime?.hours?.value
    );
    const endTimeMinute = parseInt(
      listing?.attributes?.publicData?.recurringScheduleList?.[0]?.endTime?.min?.value
    );

    startDate = moment(listing?.attributes?.publicData?.recurringScheduleList?.[0]?.startDate?.date)
      .set({ hours: startTimeHour, minutes: startTimeMinute })
      .add(userOffeset, 'm');

    endDate = moment(listing?.attributes?.publicData?.recurringScheduleList?.[0]?.endDate?.date)
      .set({ hours: endTimeHour, minutes: endTimeMinute })
      .add(userOffeset, 'm');

    if (startTimeHour > endTimeHour) {
      endDate.add(1, 'day');
    }

    const startDateLoop = startDate.clone();
    const reccuringInterval =
      listing?.attributes?.publicData?.recurringScheduleList?.[0]?.recurringInterval?.value;
    let recurringDays = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];

    if (reccuringInterval === 'Weekly') {
      recurringDays = listing?.attributes?.publicData?.recurringScheduleList?.[0]?.recurringDays?.split(
        ','
      );
    }
    while (startDateLoop.isSameOrBefore(endDate)) {
      const dayName = startDateLoop.format('dddd');
      if (recurringDays.includes(dayName)) {
        let { startingShiftDateTime, endingShiftDateTime } = {};

        endingShiftDateTime = startDateLoop
          .clone()
          .set({ hours: endTimeHour, minutes: endTimeMinute });

        startingShiftDateTime = startDateLoop
          .clone()
          .set({ hours: startTimeHour, minutes: startTimeMinute });

        if (startTimeHour > endTimeHour) {
          endingShiftDateTime.add(1, 'day');
        }

        attendanceArray = [
          ...attendanceArray,
          {
            startingShiftDateTime: new Date(startingShiftDateTime).toISOString(),
            endingShiftDateTime: new Date(endingShiftDateTime).toISOString(),
          },
        ];
      }
      startDateLoop.add(1, 'day');
    }
  }
  return attendanceArray;
};

export function useIsWorkerTimeslotBlocked(listing, workerTimeslot) {
  const isTimeslotBlocked = useMemo(() => {
    if (listing && listing.id && listing.id.uuid) {
      const listingTimes = constructTimesArray(listing);

      return checkCollision(listingTimes, workerTimeslot);
    }
    return true;
  }, [listing?.id?.uuid, workerTimeslot]);

  return isTimeslotBlocked;
}
